/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Box, Autocomplete } from "@mui/material";
// import * as React from "react";
import React, { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { useParams } from "react-router-dom";
import moment from "moment";
import dayjs from "dayjs";
import CachedIcon from "@mui/icons-material/Cached";
import Button from "../../../components/Layout/Button";
import Modal from "../../../components/Modal/Modal";
import Typography from "../../../components/Typography/Typography";
import InputField from "../../../components/Layout/fieldInput/InputField";
import { SERVICES } from "../../../components/Layout/Services";
import {
  get,
  newGet,
  put,
} from "../../../components/Layout/ApiHandler/apihandler";
import { ToastAlertContext } from "../../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../../contants";
import OrganizationStructureChapterLevel from "../../../components/Layout/OrganizationStructure/OrganizationStructureChapterLevel";
import AutoCompleteDropdown from "../../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
import BasicDatePicker from "../../../components/DatePicker/BasicDatePickerV2";
import DateRangePicker from "../../Reports/Components/DateRangePicker/DateRangePicker";

const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));

const initialFormValues = {
  areaId: null,
  zoneId: null,
  regionId: null,
  chapterId: null,
};
const initialFormValue = {
  fromDate: new Date(),
  toDate: new Date(),
};

export default function EditBankDepositModal({
  open,
  onClose,
  editId,
  fromDate,
  toDate,
  getBankDetails,
}) {
  const [bankTypes, setBankTypes] = useState([]);
  const [selectedBankType, setSelectedBankType] = useState("");
  const [selectedBankName, setSelectedBankName] = useState("");
  const [values, setValues] = useState({
    areaId: initialFormValues.areaId,
    zoneId: initialFormValues.zoneId,
    regionId: initialFormValues.regionId,
    chapterId: initialFormValues.chapterId,
  });
  const [amountValue, setAmountValue] = useState("");
  const [memberId, setMemberId] = useState("");
  const [selectedDepositDate, setSelectedDepositDate] = useState(null);
  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedToDate, setSelectedToDate] = useState(null);
  const [bankDetails, setBankDetails] = useState({});
  // const [chequeAmountValue, setChequeAmountValue] = useState("");
  // const [ddAmountValue, setDDAmountValue] = useState("");
  const [cashTotal, setCashTotal] = useState(null);
  const [chequeAmountValueSameBank, setChequeAmountValueSameBank] =
    useState(null);
  const [chequeAmountValueDifferentBank, setChequeAmountValueDifferentBank] =
    useState(null);
  const [ddTotal, setDDTotal] = useState(null);
  const [total, setTotal] = useState(null);
  const toast = React.useContext(ToastAlertContext);
  const [profileData, setProfileData] = useState({});
  const [debouncedMemberId, setDebouncedMemberId] = useState(memberId);
  const [selectedMember, setSelectedMember] = useState(null);
  const [members, setMembers] = useState([]);
  const [userData, setUserData] = useState("");
  const [showAutoComplete, setAutoComplete] = useState(false);
  const updateOrganizationStructureValues = (updatedValues) => {
    setValues(updatedValues);
  };
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);
  // const handleAmountChange = (value) => {
  //   setAmountValue(value);
  // };
  // const handleChequeAmountChange = (value) => {
  //   setChequeAmountValue(value);
  // };
  // const handleDDAmountChange = (value) => {
  //   setDDAmountValue(value);
  // };
  const handleAmountChange = (value) => {
    setCashTotal(value);
  };
  const handleChequeAmountSameChange = (value) => {
    setChequeAmountValueSameBank(value);
  };
  const handleChequeAmountDiffChange = (value) => {
    setChequeAmountValueDifferentBank(value);
  };
  const handleDDAmountChange = (value) => {
    setDDTotal(value);
  };
  const handleTotalAmount = (value) => {
    setTotal(value);
  };
  const handleMemberId = (value) => {
    setMemberId(value);
    if (value) {
      setAutoComplete(true);
    }
  };
  const handleDepositDateChange = (date) => {
    const formattedDate = dayjs(date.$d).format("YYYY-MM-DDTHH:mm:ss");
    setSelectedDepositDate(formattedDate);
  };

  const handleFromDateChange = (date) => {
    const formattedDate = dayjs(date.$d).format("YYYY-MM-DDTHH:mm:ss");
    setSelectedFromDate(formattedDate);
  };

  const handleToDateChange = (date) => {
    const formattedDate = dayjs(date.$d).format("YYYY-MM-DDTHH:mm:ss");
    setSelectedToDate(formattedDate);
  };

  function formatDateToYYYYMMDD(date) {
    return moment(date).format("YYYY-MM-DDTHH:mm:ss");
  }

  const validateBankDetails = () => {
    if (!selectedBankType) {
      toast.show("Please Select Bank", AlertStatus.ERROR);
      return false;
    }
    if (!amountValue) {
      toast.show("Please Enter Amount", AlertStatus.ERROR);
      return false;
    }
    if (!memberId) {
      toast.show("Please Enter MemberId", AlertStatus.ERROR);
      return false;
    }
    if (!selectedDepositDate) {
      toast.show("Please Select Deposit Date", AlertStatus.ERROR);
      return false;
    }
    // if (!selectedFromDate) {
    //   toast.show("Please Select From Date", AlertStatus.ERROR);
    //   return false;
    // }
    // if (!selectedToDate) {
    //   toast.show("Please Select To Date", AlertStatus.ERROR);
    //   return false;
    // }
    return true;
  };

  // const handleBankTypes = async () => {
  //   try {
  //     const url = `${SERVICES.GET_BSG_BANKS}`;
  //     const response = await get(url);
  //     if (response.ok) {
  //       const data = await response.json();
  //       setBankTypes(data.data);
  //     }
  //   } catch (error) {
  //     Sentry.captureException(error);
  //   }
  // };

  const handleBankTypes = async () => {
    try {
      // const url = `${SERVICES.GET_BSG_BANKS}`;
      const url = `${SERVICES.BANKS_DETAILS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const bankList = data?.data?.content;
        setBankTypes(bankList);
        for (const bank of bankList) {
          const bankId = bank.id;
          const branchUrl = `${SERVICES.BANKS_DETAILS}/${bankId}/branches`;
          const branchResponse = await get(branchUrl);

          if (branchResponse.ok) {
            const branchData = await branchResponse.json();
            const defaultBranch = branchData.data.find(
              (branch) => branch.defaultForCa === true,
            );

            if (defaultBranch) {
              setSelectedBankType(defaultBranch?.bank?.id);
            }
          }
        }
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const getBankData = async () => {
    try {
      const url = `${SERVICES.OFFLINE_BANK_DEPOSIT}/${editId}?paymentOrderFrom=${fromDate}&paymentOrderTo=${toDate}`;
      const response = await newGet(url);
      if (response.ok) {
        const data = await response.json();
        const bankData = data?.data;
        if (bankData) {
          setBankDetails(bankData);
          // update states
          setSelectedBankType(bankData.bankId);
          setSelectedBankName(bankData.bankName);
          setValues({
            areaId: bankData.areaId,
            zoneId: bankData.zoneId,
            regionId: bankData.regionId,
            chapterId: bankData.chapterId,
          });
          setMemberId(bankData?.depositedBy);
          setSelectedDepositDate(dayjs(bankData?.depositedAt));
          setAmountValue(bankData.amount.toString());
          setCashTotal(bankData?.cashTotal.toString());
          setChequeAmountValueSameBank(
            bankData?.chequeTotalSameBank.toString(),
          );
          setChequeAmountValueDifferentBank(
            bankData?.chequeTotalDifferentBank.toString(),
          );
        } else {
          console.error("No bank data found with the given editId");
        }
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handleSubmit = async () => {
    if (!validateBankDetails()) {
      return;
    }
    const extractedMemberId =
      typeof memberId === "string" && memberId.includes(" - ")
        ? memberId.split(" - ")[0]
        : memberId || null;
    const data = {
      bankName: selectedBankName,
      areaId: values.areaId,
      zoneId: values.zoneId,
      regionId: values.regionId,
      chapterId: values.chapterId,
      bankId: selectedBankType,
      status: "DEPOSITED",
      depositedAt: selectedDepositDate,
      depositedBy: extractedMemberId,
      paymentOrderFrom: fromDate,
      paymentOrderTo: toDate,
      amount: Number(amountValue),
    };
    const url = `${SERVICES.OFFLINE_BANK_DEPOSIT}/${editId}`;
    try {
      const response = await put(url, data);
      if (response.ok) {
        toast.show("Details Updated Successfully", AlertStatus.SUCCESS);
        onClose();
        await getBankDetails();
      }
    } catch (error) {
      toast.show(error.message || "Something went wrong", AlertStatus.ERROR);
    }
  };
  useEffect(() => {
    handleBankTypes();
    getUserRole();
  }, []);
  useEffect(() => {
    if (open && editId) {
      getBankData();
    }
  }, [open, editId]);
  useEffect(() => {
    if (!open) {
      setValues(initialFormValues);
      setInitialAdvanceFormValue(initialFormValue);
      setAutoComplete(false);
      setSelectedMember(null);
    }
  }, [open]);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedMemberId(memberId);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [memberId]);
  const getMemberDeatils = async () => {
    const numericMemberId =
      String(debouncedMemberId).match(/\d+/)?.[0] || debouncedMemberId;
    try {
      const url = `${SERVICES.GET_MEMBER_SEARCH}?inOrganisationStructure=true&memberId=${numericMemberId}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setMembers(data?.data?.content);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const getChapterContributionCycle = async () => {
    const formattedStartDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.fromDate,
    );
    const formattedEndDate = formatDateToYYYYMMDD(
      initialAdvanceFormValue.toDate,
    );
    try {
      const url = `${SERVICES.CHAPTER_CONTRIBUTION_CYCLE}/${values.chapterId}?paymentOrderFrom=${formattedStartDate}&paymentOrderTo=${formattedEndDate}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        // setProfileData(data.data);
        // setChapterContributionCycle(data.data);
        setSelectedBankType(data.data.defaultDepositBankId);
        setCashTotal(data.data.cashTotal);
        setDDTotal(data.data.ddTotal);
        setAmountValue(data.data.total);
        setChequeAmountValueSameBank(data.data.chequeTotalSameBank);
        setChequeAmountValueDifferentBank(data.data.chequeTotalDifferentBank);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  useEffect(() => {
    if (debouncedMemberId) {
      getMemberDeatils();
    }
  }, [debouncedMemberId]);
  return (
    <Box tabIndex="0">
      <Modal open={open} onClose={onClose}>
        <Typography
          style={{
            fontSize: "20px ",
            fontWeight: "500",
            paddingBottom: "20px",
          }}
        >
          {profileData?.assignedRoles?.includes("contributionAdmin")
            ? "View Bank Details"
            : "Edit Bank Details"}
        </Typography>
        <Box sx={{ padding: "12px 24px", marginTop: "10px" }}>
          <Typography>Org Structure</Typography>
          <OrganizationStructureChapterLevel
            onUpdateValues={updateOrganizationStructureValues}
            initialAreaId={values.areaId}
            initialZoneId={values.zoneId}
            initialRegionId={values.regionId}
            initialChapterId={values.chapterId}
            disabled
            // disabled={profileData?.assignedRoles?.includes("contributionAdmin")}
          />
        </Box>
        {profileData?.assignedRoles?.includes("contributionAdmin") && (
          <>
            <Box
              sx={{
                display: "flex",
                gap: "20px",
                alignItems: "center",
                // marginBottom: "20px",
              }}
            >
              <Box sx={{ width: "30%", paddingLeft: "24px" }}>
                <DateRangePicker
                  label="Contribution Date"
                  name="date"
                  startDateVal={initialAdvanceFormValue.fromDate}
                  endDateVal={initialAdvanceFormValue.toDate}
                  onChange={(startDate, endDate) => {
                    setInitialAdvanceFormValue({
                      ...initialAdvanceFormValue,
                      fromDate: startDate,
                      toDate: endDate,
                    });
                  }}
                />
              </Box>
              <CachedIcon
                sx={{ cursor: "pointer" }}
                onClick={() => getChapterContributionCycle()}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                // gap: "10px",
                // alignItems: "center",
                paddingLeft: "24px",
                paddingTop: "10px",
              }}
            >
              {/* <Typography sx={{ color: "Red" }}>
                Steps to upload deposit slips:
              </Typography> */}
              <Typography sx={{ color: "Red" }}>
                Select "Contribution Date"
              </Typography>
              <Typography sx={{ color: "Red" }}>
                Press the{" "}
                <span style={{ fontWeight: "bold" }}>"Refresh" Icon</span> This
                will update all figures on the form.
              </Typography>
            </Box>
          </>
        )}
        <Box
          sx={{
            display: "flex",
            padding: "12px 24px",
            alignItems: "center",
            gap: "146px",
            alignSelf: "stretch",
          }}
        >
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.bankName}
            options={getOptions(bankTypes, "id")}
            label="Drawn on Bank"
            name="paymentMethods"
            value={selectedBankType}
            onChange={(selectedValue) => {
              setSelectedBankType(selectedValue?.value);
              setSelectedBankName(selectedValue?.bankName);
            }}
            inputProps={{ required: true }}
            useHiddenInput
            style={{ width: "350px" }}
            disabled
          />
          <InputField
            label="Cash Deposit Total"
            name="amount"
            required
            value={cashTotal ?? 0}
            onChange={(event) => {
              const { value } = event.target;
              handleAmountChange(value);
            }}
            disabled
            style={{ width: "350px" }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            padding: "12px 24px",
            alignItems: "center",
            gap: "146px",
            alignSelf: "stretch",
          }}
        >
          <InputField
            label="Total Cheque/DD Amount (Same Bank)"
            name="amount"
            required
            value={chequeAmountValueSameBank ?? 0}
            onChange={(event) => {
              const { value } = event.target;
              handleChequeAmountSameChange(value);
            }}
            disabled
            style={{ width: "350px" }}
          />
          <InputField
            label="Total Cheque/DD Amount (Different Bank)"
            name="amount"
            required
            value={chequeAmountValueDifferentBank ?? 0}
            onChange={(event) => {
              const { value } = event.target;
              handleChequeAmountDiffChange(value);
            }}
            disabled
            style={{ width: "350px" }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            padding: "12px 24px",
            alignItems: "center",
            gap: "146px",
            alignSelf: "stretch",
          }}
        >
          {/* <InputField
            label="DD Total"
            name="amount"
            required
            value={ddTotal ?? 0}
            onChange={(event) => {
              const { value } = event.target;
              handleDDAmountChange(value);
            }}
            disabled
            style={{ width: "350px" }}
          /> */}
          <InputField
            label="Total"
            name="amount"
            required
            value={amountValue ?? 0}
            onChange={(event) => {
              const { value } = event.target;
              handleTotalAmount(value);
            }}
            disabled
            style={{ width: "350px" }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            padding: "12px 24px",
            alignItems: "center",
            gap: "146px",
            alignSelf: "stretch",
          }}
        >
          {showAutoComplete ? (
            <Autocomplete
              options={members}
              getOptionLabel={(option) => `${option.id} - (${option.fullName})`}
              value={selectedMember}
              onChange={(event, newValue) => {
                setSelectedMember(newValue);
                if (newValue) {
                  setMemberId(`${newValue.id} - (${newValue.fullName})`);
                }
              }}
              inputValue={memberId}
              onInputChange={(event, newInputValue) => {
                setMemberId(newInputValue);
              }}
              renderInput={(params) => (
                <InputField
                  {...params}
                  label="Member Id (Deposited by)"
                  InputLabelProps={{
                    shrink: !!memberId,
                    sx: {
                      fontSize: "14px",
                      transform: "translate(16px, 11px) scale(1)",
                      "&.MuiInputLabel-shrink": {
                        transform: "translate(16px, -9px) scale(0.75)",
                      },
                    },
                  }}
                />
              )}
              style={{
                width: 350,
              }}
            />
          ) : (
            <InputField
              label="Member Id (Deposited by)"
              required
              value={memberId}
              // inputProps={{ type: "number" }}
              onChange={(event) => {
                const { value } = event.target;
                handleMemberId(value);
              }}
              style={{ width: "350px" }}
              disabled={profileData?.assignedRoles?.includes(
                "contributionAdmin",
              )}
            />
          )}
          <BasicDatePicker
            label="Deposit Date"
            sx={{
              width: "350px",
              backgroundColor: "white",
            }}
            onChange={handleDepositDateChange}
            value={dayjs(selectedDepositDate)}
            required
            disabled={profileData?.assignedRoles?.includes("contributionAdmin")}
          />
        </Box>
        {/* <Box
          sx={{
            display: "flex",
            padding: "12px 24px",
            alignItems: "center",
            gap: "146px",
            alignSelf: "stretch",
          }}
        >
          <BasicDatePicker
            label="Date From"
            sx={{
              width: "350px",
              backgroundColor: "white",
            }}
            onChange={handleFromDateChange}
            value={dayjs(selectedFromDate)}
            required
            disabled={profileData?.assignedRoles?.includes("contributionAdmin")}
          />
          <BasicDatePicker
            label="Date To"
            sx={{
              width: "350px",
              backgroundColor: "white",
            }}
            onChange={handleToDateChange}
            value={dayjs(selectedToDate)}
            required
            disabled={profileData?.assignedRoles?.includes("contributionAdmin")}
          />
        </Box> */}
        {profileData?.assignedRoles?.includes(
          "contributionOfflineDataEntry",
        ) && (
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={handleSubmit}
              width="40%"
              style={{
                marginRight: "10px",
              }}
            >
              Yes
            </Button>
            <Button
              onClick={onClose}
              cancel
              width="40%"
              style={{
                marginRight: "10px",
              }}
            >
              No
            </Button>
          </Box>
        )}
      </Modal>
    </Box>
  );
}
